import { render, staticRenderFns } from "./CustomQuestion.vue?vue&type=template&id=2de4a13e&scoped=true&"
import script from "./CustomQuestion.vue?vue&type=script&lang=js&"
export * from "./CustomQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CustomQuestion.vue?vue&type=style&index=0&id=2de4a13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de4a13e",
  null
  
)

export default component.exports